module.exports = __webpack_public_path__ + "static/media/brand09.2c1dd2d2.png";